import Expand from "@shared/assets/eds-custom-icons/Expand.svg?react";
import styled from "styled-components";
import { ZoomInput } from "./ZoomInput";

interface ZoomControlProps {
  readonly value: number;
  readonly zoomToFit: () => void;
  readonly setZoomLevel: (zoomLevel?: number) => void;
}

export function ZoomControl({ value, zoomToFit, setZoomLevel }: ZoomControlProps) {
  return (
    <StyledZoomControlContainer>
      {/*<StyledZoomControlText>{value}%</StyledZoomControlText>*/}
      <ZoomInput value={value} onValueChange={setZoomLevel} width={82} />
      <tractie-button
        data-testid="zoom-control-fit-button"
        level="tertiary"
        icon-only
        onClick={zoomToFit}
      >
        <Expand />
        Passend maken
      </tractie-button>
    </StyledZoomControlContainer>
  );
}

const StyledZoomControlContainer = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.backgroundElevated1};
  display: flex;
  flex-direction: row;
  gap: 0;
  z-index: 60;
  border-radius: 6px;
  padding: 0 8px;
  ${({ theme }) => theme.boxShadow};
`;
